module.exports = __webpack_public_path__ + "img/design1.f3ca92ef.png";